import { toast } from "react-toastify";

const handleMessage = (message: string, autoClose: false | number) => {
  if (autoClose !== false) return message;
  return (
    <>
      <div>{message}</div>
      <div className="text-xs">Click to close</div>
    </>
  );
};

const success = (message: string, autoClose: false | number = 4500) => {
  toast.success(handleMessage(message, autoClose), {
    toastId: message,
    autoClose,
  });
};

const error = (message: string, autoClose: false | number = 4500) => {
  toast.error(handleMessage(message, autoClose), {
    toastId: message,
    autoClose,
  });
};

const warning = (message: string, autoClose: false | number = 4500) => {
  toast.warning(handleMessage(message, autoClose), {
    toastId: message,
    autoClose,
  });
};

const info = (message: string, autoClose: false | number = 4500) => {
  toast.info(handleMessage(message, autoClose), {
    toastId: message,
    autoClose,
  });
};

export const tMsg = {
  success,
  error,
  warning,
  info,
};
